module.exports = __webpack_public_path__ + "img/1592936224.7099a77e.jpg";